import { ReactNode } from 'react';

import { Align, FlexItem, Justify, View } from '@bytel/trilogy-react';

interface OfferItemBlockProps {
    children: ReactNode;
}

export const OfferItemBlock = ({ children }: Readonly<OfferItemBlockProps>) => {
    return (
        <FlexItem className='has-background-grey-fade rounded-col p-small'>
            <View flexable justify={Justify.SPACE_BETWEEN} align={Align.CENTER} className='is-fullheight gap-medium'>
                {children}
            </View>
        </FlexItem>
    );
};
